<template>
  <v-dialog v-model="show" width="40vw" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable persistent>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2"> Nueva OP </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="loteForm" lazy-validation>
            <v-row no-gutters>
              <v-col cols="12">
                <v-text-field label="Nombre del cliente" dense outlined clearable :rules="validation()" type="text"
                  v-model="client"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-combobox label="Selecciona tipo de venta" dense outlined clearable :rules="validation()" type="text"
                  item-text="name" :items="saleTypes" return-object v-model="saleType"></v-combobox>
              </v-col>
              <v-col cols="12">
                <v-autocomplete label="Selecciona el destino" dense outlined clearable type="text" item-text="name"
                  no-data-text="Dirección no encontrada" :items="addressList" return-object v-model="address"
                  :loading="retrievingAddressList" :search-input.sync="search"></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Nombre de etiqueta" dense outlined clearable type="text"
                  v-model="label"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn color="red" block @click="closeModal()" dark :disabled="isLoading">Cancelar</v-btn>
            </v-col>
            <v-col>
              <v-btn color="primary" block @click="confirmation" :loading="isLoading">Crear orden</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    <ProductModal v-model="showNewProduct" v-if="showNewProduct" @addProduct="addProduct"
      @updateProduct="updateProductList" />
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapMutations } from "vuex";
//axios
import axios from "axios";
//validations
import { requiredValidation, requiredMultiple } from "@/helpers/validations.js";
// date library
import dayjs from "dayjs";
//components
import ProductModal from "@/components/dashboard/production-orders/modals/ProductModal.vue";
export default {
  components: {
    ProductModal,
  },
  data: () => ({
    isLoading: false,
    user: JSON.parse(localStorage.getItem("user")),
    showNewProduct: false,
    client: null,
    saleType: null,
    label: null,
    saleTypes: [
      { name: "R", value: "R" },
      { name: "OP", value: "OP" },
      { name: "P", value: "P" },
      { name: "OR", value: "OR" },
      { name: "I", value: "I" },
      { name: "M", value: "M" },
      { name: "KIT", value: "KIT" },
    ],
    addressList: [],
    address: null,
    search: null,
    retrievingAddressList: false
  }),
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  async created() {
    await this.getAddressList()
  },
  methods: {
    ...mapActions("address", ["getAddress"]),
    ...mapActions("order", ["addOrder"]),
    ...mapMutations("order", [
      "SET_ORDER_TO_UPDATE"
    ]),
    closeModal() {
      this.show = false;
    },
    async confirmation() {
      //emit fetch table
      if (this.$refs.loteForm.validate()) {
        try {
          this.isLoading = true;
          let payload = {
            client: this.client,
            user: this.user,
            saleType: this.saleType.value,
            label: this.label,
            address: this.address
          };

          let response = await this.addOrder(payload);
          this.SET_ORDER_TO_UPDATE(response.order);

          this.$swal({
            icon: "success",
            title: `OP creada`,
            showConfirmButton: false,
            timer: 2000,
          });
          this.$emit("update");
        } catch (e) {
          console.log(e);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al crear OP. Error: ${error.message}`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoading = false;
      }
    },

    validation(name) {
      return requiredValidation(name);
    },
    async getAddressList() {
      try {
        this.retrievingAddressList = true
        let payload = {
          search: this.search,
          rowPerPage: 20
        }
        let response = await this.getAddress(payload)
        this.addressList = response.addressList
      } catch (error) {
        console.log(error);
      } finally {
        this.retrievingAddressList = false
      }
    }
  },
  watch: {
    async search() {
      await this.getAddressList()
    }
  }
};
</script>

<style scoped>
.decrease {
  background-color: red;
  color: white;
}
</style>
